import { defineComponent } from '@vue/composition-api';
import { jumpOneLinkForCommon } from '@/utils/jump-link';
import { isInApp } from '@/utils/yoda'; // 端外点击按钮跳转到端内

export default defineComponent({
  components: {},
  emits: ['click'],
  setup: function setup(props, ctx) {
    var handleClick = function handleClick(event) {
      if (!isInApp) {
        var urlObj = new URL(window.location.href);
        jumpOneLinkForCommon(urlObj.href, {
          timeout: 3000
        });
        event.stopPropagation();
      } else {
        ctx.emit('click', event);
      }
    };

    return {
      handleClick: handleClick
    };
  }
});